/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_PricingInputs */

const en_mk_nav_pricing = /** @type {(inputs: Mk_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const id_mk_nav_pricing = /** @type {(inputs: Mk_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Mk_Nav_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_pricing = /** @type {((inputs?: Mk_Nav_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_pricing(inputs)
	return en_mk_nav_pricing(inputs)
});